<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
  
    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @search="handleSearch"
                            :btn_show="true"
                            :btn_edit="false"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            :btn_destroy="true"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        
                           />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <alertmodal></alertmodal>
  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables_onlineclass_quizkomunikasi.vue' 
import axios from 'axios';
import EventBus from '@/eventBus';

import onlineclass from '@/services/onlineclass';

import alertmodal from '@/views/alert/modal.vue';
import Multiselect from 'vue-multiselect'

const token = localStorage.getItem('token');

export default {
  name: 'MemberTables',
  components: { Datatable, alertmodal,Multiselect },
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      
      updateSubmit: false,
      fields: [
          {key: 'fullname', sortable: false, },
          {key: 'email', sortable: false},
          {key: 'gender', sortable: false},
          //{key: 'teacher_name', sortable: false},
          {key: 'created_at', sortable: false},
          {key: 'result', sortable: false},
          {key: 'action', sortable: false},
        //   {key: 'notes', sortable: false, label: 'aa'},
        //   {key: 'tithing', sortable: false, thStyle: { backgroundColor: '#3eef33'}},
        //   {key: 'member_attendance', sortable: false},
        //   {key: 'visitor_attendance', sortable: false},
        //   {key: 'created_at', sortable: false},
          // {key: 'covenant_date', sortable: false},
          // {key: 'volunteer_date', sortable: false},
      ],
      items: [],
      options_member:[],
      options_service:[],
      options_keperluan: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      options_icare: [],
      options_month: [
        {text: "January", value: "1"},
        {text: "February", value: "2"},
        {text: "March", value: "3"},
        {text: "April", value: "4"},
        {text: "May", value: "5"},
        {text: "June", value: "6"},
        {text: "July", value: "7"},
        {text: "August", value: "8"},
        {text: "September", value: "9"},
        {text: "October", value: "10"},
        {text: "November", value: "11"},
        {text: "December", value: "12"},
      
      ],
      options_year: [],

      getIcare: [],
      getMonth: [],
      getYear: [],

      icare: '',
      month: '',
      year: ''
    }
   },
    created() {
  },

   mounted (){
     this.loadData()
     this.loadPeriod()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
     loadData(p) {


      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        icare: this.icare,
        month: this.month,
        year: this.year
      }

      


      onlineclass.getResultQuizKomunikasi(params)
      .then(res => {

          let getData = res.data

          this.items = getData.data

          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },

    openShow(id){
        this.$router.push({name:'Detail Quiz Komunikasi',query: {id:id} }) 
        console.log(' open show detail')
    },

    filter(){
      this.loadData()
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },   

  }
  
}
</script>

<style>

</style>
